export default "__VITE_ASSET__BOCwNgpM__"